import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Evaluacion360Page = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setError('Esta página requiere autenticación real del empleado. Use el sistema de login unificado en la página principal.');
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex justify-center items-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
        <span className="ml-3 text-gray-600">Cargando...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex justify-center items-center">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
          <h3 className="text-lg font-medium text-red-800">Página de Prueba</h3>
          <p className="mt-2 text-red-700">{error}</p>
          <div className="mt-4">
            <a 
              href="/" 
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
            >
              Ir al Login Principal
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold leading-tight text-gray-900">
            🔄 Evaluación 360° - Página de Prueba
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            Esta es una página de prueba para el sistema de evaluación
          </p>
        </div>
      </div>
    </div>
  );
};

export default Evaluacion360Page;